import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewMailGordos = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'mail_gordos', // Cambiar
        name: 'Cuadro de Gordos', // Cambiar
        component: ViewMailGordos,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
